module.exports = __webpack_public_path__ + "img/big_data.b08cd354.png";